<template>
  <table id="draggabletable" class="table table-striped table-bordered">
    <thead>
      <tr>
        <th
          v-for="(item, key, index) in columnTitles"
          :key="index"
          :toggle="currentToggle"
          :class="{ bgr: isItMoving }"
          class="flat"
          style="word-break: keep-all"
        >
          {{ item }}
        </th>
      </tr>
    </thead>
    <draggable
      v-model="tableRow"
      :tag="'tbody'"
      :move="beforeMove"
      @end="onEnd"
      handle=".handle"
    >
      <tr v-for="(list, key, index) in tableRow" :key="index">
        <td
          v-for="(value, key2, index2) in list"
          :key="index2"
          :class="{ handle: key2 === 0 }"
        >
          <template v-if="identifyContentsOfTheColumn(value) === 'object'">
            <actionButton
              v-if="value.type !== 'checkBox'"
              :id="value.id"
              :type="value.type"
              @buttonClickEvent="buttonClickEvent"
            />
          </template>
          <template v-else-if="identifyContentsOfTheColumn(value) === 'array'">
            <actionButton
              v-for="(button, key3, index3) in value"
              :id="button.id"
              :key="index3"
              :type="button.type"
              @buttonClickEvent="buttonClickEvent"
            />
          </template>
          <template v-else>{{ value }}</template>
        </td>
      </tr>
    </draggable>
  </table>
</template>
<script>
import Button from '@/components/common/table/button'
import draggable from 'vuedraggable'
export default {
  components: {
    actionButton: Button,
    draggable,
  },
  props: ['columnTitles', 'displayItems'],
  data() {
    return {
      currentToggle: 0,
      tableRow: this.displayItems,
      isItMoving: false,
    }
  },
  watch: {
    displayItems: function(val) {
      this.tableRow = val
    },
    tableRow: function() {
      this.reflectChange()
    },
  },
  methods: {
    identifyContentsOfTheColumn: function(value) {
      if (Array.isArray(value)) {
        // ボタンが複数あるカラムを想定
        return 'array'
      } else if (typeof value === 'object') {
        // 単一のボタンしかないカラムを想定
        return 'object'
      } else {
        // 値をそのまま返す
        return 'string'
      }
    },
    buttonClickEvent: function(type, id) {
      this.$emit('buttonClickEvent', type, id)
    },
    reflectChange: function() {
      this.$emit('reflectChange', this.tableRow)
    },
    toggleSort: function(event) {
      var cell = event.target
      var order = 1
      if (cell.className === 'asc') {
        cell.className = 'dec'
        order = -1
      } else if (cell.className === 'dec') {
        cell.className = 'asc'
        order = 1
      } else {
        cell.className = 'asc'
        order = 1
      }
      var cellIndex = event.target.cellIndex
      this.arraySort(this.displayItems, cellIndex, order)
    },
    beforeMove: function() {
      this.isItMoving = true
    },
    onEnd: function() {
      this.isItMoving = false
    },
  },
}
</script>
<style scoped>
.handle {
  cursor: move;
}
.bgr {
  background-color: rgb(231, 76, 60, 0.88);
  color: #ffffff;
}
</style>
